import {LIMPAR_ULTIMOS_HISTORICOS_TRECHO} from '../types';

export default function limparUltimosHistoricosTrecho () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_TRECHO
    }
}
